import {
  APOLITIRIO,
  NAUTICAL104,
  NAUTICAL260,
  NAUTICALPDBLUE,
  NAUTICALPDRED,
  APOLITIRIOGIMNASIOU,
  APOLITIRIODIMITIKOU,
} from "../constants";

// It's simpler than it seems , it checks for Apolitirio and replaces the words and puts the required flags depended on what the applicant choose at first

export const documentsRequiredFiltered = (table, nauticalPdColor) => {
  let documentsperKindRequired = [];
  const docsPerKindbasedOnPd = table?.map((doc) => {
    if (doc.docCategory === APOLITIRIO) {
      if (nauticalPdColor === NAUTICALPDBLUE) {
        return {
          ...doc,
          dscr: APOLITIRIOGIMNASIOU,
          document: APOLITIRIOGIMNASIOU,
        };
      } else if (nauticalPdColor === NAUTICALPDRED) {
        return {
          ...doc,
          document: APOLITIRIODIMITIKOU,
          dscr: APOLITIRIODIMITIKOU,
        };
      }
    } else if (doc.id === NAUTICAL104) {
      if (nauticalPdColor === NAUTICALPDBLUE) {
        return {
          ...doc,
          // req_flg: 1,
        };
      } else {
        return { ...doc };
      }
    } else if (doc.id === NAUTICAL260) {
      if (nauticalPdColor === NAUTICALPDRED) {
        return {
          ...doc,
          // req_flg: 0,
        };
      } else {
        return { ...doc };
      }
    } else {
      return { ...doc };
    }
  });

  // Filters out the option we don't want for the Ptixio Swstikon
  nauticalPdColor === NAUTICALPDBLUE
    ? documentsperKindRequired.push(
      docsPerKindbasedOnPd?.filter((doc) => {
        return doc.id !== NAUTICAL260;
      })
    )
    : documentsperKindRequired.push(
      docsPerKindbasedOnPd?.filter((doc) => {
        return doc.id !== NAUTICAL104;
      })
    );


  return documentsperKindRequired[0];
};
